// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_GxpjA){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2izCS .dualColumn_35Siu{display:flex;align-content:space-between}.nsAddressForm_2izCS .dualColumn_35Siu .firstCol_1jWod{margin-right:20px}.optional_3w3fn{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_GxpjA",
	"nsAddressForm": "nsAddressForm_2izCS",
	"dualColumn": "dualColumn_35Siu",
	"firstCol": "firstCol_1jWod",
	"optional": "optional_3w3fn"
};
module.exports = exports;
